var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Inicio")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/Juegos"}},[_vm._v("Juegos")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/Contacto"}},[_vm._v("Contacto")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }